import React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ResponsiveAppBar from "../../components/shared/Menubar/ResponsiveAppBar";
import { AdminService, WLOCreditAPIService } from "../../services";
import { WloCreditoService } from "../../types";
import './new.scss';
import Moment from 'moment';

import NumberFormat from 'react-number-format';
interface PDFProps {
}

export function NewPdf(_props: PDFProps) {
  const navigate = useNavigate();
  const buscar = useLocation();
  const [datInicial, setInicial] = React.useState({} as any);
  const [arreglos, setDatoArr] = React.useState([] as any);
  const [datInicial2, setInicial2] = React.useState({} as any);
  const [datInicial3, setInicial3] = React.useState({} as any);
  const [allCities, setAllCities] = React.useState([] as any);
  useEffect(()=>{
    if(buscar){
      var valorBusqueda=buscar.search.replace("?","")
     let arreglo=String(valorBusqueda).split("-")
     setDatoArr(arreglo)
     getConsultas(arreglo)
    }
    },[buscar,navigate]);
    const getConsultas =(arreglo:string[])=>{
      let sends:WloCreditoService.SolicitudDetalla={
          Pws_Num_Solicitud:arreglo[0],
          Pws_Identificacion:arreglo[1],
          Pws_Tip_Identificacion:arreglo[2],
          Pws_Perfil_Acceso:"",
          Pws_Fec_Solicitud:"",
      }
      AdminService.getAllCiudades().then((AllCities)=>{
        setAllCities(AllCities.payload.data.ListCiudad.Datos_Ciudad)
      })
      if(arreglo.length>0){
          WLOCreditAPIService.consultaSolicitudCygnusDetal(sends).then((valor)=>{
            if(valor.payload){
              if(valor.payload.data){
                console.log(valor.payload.data)
                if(valor.payload.data.datos_persona){
                  if(valor.payload.data.datos_persona.Datos_persona.length>0){
                    
                    setInicial(valor.payload.data.datos_persona.Datos_persona[0])
                  }
                }
                if(valor.payload.data.datos_operfinan){
                  if(valor.payload.data.datos_operfinan.Datos_operfinan.length>0){
                    
                    setInicial2(valor.payload.data.datos_operfinan.Datos_operfinan[0])
                  }
                }
                if(valor.payload.data.datos_peps){
                  if(valor.payload.data.datos_peps.Datos_peps.length>0){
                    
                    setInicial3(valor.payload.data.datos_peps.Datos_peps[0])
                  }
                }

              }
            }
           },(error)=>{
           })
      }
  }
    return (

        <div>
            <div className="head">
                <img className='img-logo-black-sarmiento' src="img/Logofnancapital.PNG" alt="Sucredi"/>
                <div className="text">
                  <h2>FORMATO CONOCIMIENTO DE TERCEROS SAGRILAFT</h2>
                  <ul className="extra">
                    <li>Código: F01</li>
                    <li>Versión:  1</li>
                    <li>Fecha: 7/9/2021</li>
                  </ul>
                </div>
            </div>
            <div className="orange">1. INFORMACION GENERAL</div>
            <div className="greyOrange">
              <h4>PERSONA NATURAL</h4>
              <p>{`(Para las personas jurídicas esta información será la del representante legal)`}</p>
            </div>
            <div className="pdfbody">
              <ul>
                <li className="w-70">
                  <label htmlFor="nombre">Nombres y apellidos completos:</label>
                  <input type="text" style={{paddingLeft:"15px",fontWeight:"bolder"}} name="nombre" value={datInicial.Pws_Nombres+" "+datInicial.Pws_Apellidos1 +" "+datInicial.Pws_Apellidos2}/>
                </li>
                <li className="w-30">
                  <label htmlFor="no">No.</label>
                  <input type="text" style={{paddingLeft:"15px",fontWeight:"bolder"}} name="no"  value={datInicial.Pws_Identificacion}/>
                </li>
              </ul>
              <ul>
                <li className="w-30">
                  <label htmlFor="id">Identificación:</label>
                  <div className="sublis">
                    <label htmlFor="cc">C.C.</label>
                    <input type="text" style={{paddingLeft:"15px",fontWeight:"bolder"}} name="cc"  value={datInicial.Pws_Tip_Identificacion=="13"?"X":""}/>
                    <label htmlFor="ce">C.E.</label>
                    <input type="text" style={{paddingLeft:"15px",fontWeight:"bolder"}} name="ce" />
                    <label htmlFor="ti">T.I.</label>
                    <input type="text" style={{paddingLeft:"15px",fontWeight:"bolder"}} name="ti" />
                  </div>
                </li>
                <li className="w-30">
                  <label htmlFor="exp">Expedida en:</label>
                  <input type="text" style={{paddingLeft:"15px",fontWeight:"bolder"}} name="exp" value={allCities.filter((filtero:any)=>filtero.s_codigo==datInicial.Pws_Lugar_exp).length>0?allCities.filter((filtero:any)=>filtero.s_codigo==datInicial.Pws_Lugar_exp)[0].s_nombre:""}/>
                </li>
                <li className="w-40">
                  <label htmlFor="fechaexp">Fecha de expedición:</label>
                  <input className="w-50"type="text" name="fechaexpDate" placeholder="DD" style={{borderRight: "1px dotted #000",paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Fec_expe?datInicial.Pws_Fec_expe.split("-")[2]:""}/>
                  <input className="w-50" type="text" name="fechaexpMonth" placeholder="MM" style={{borderRight: "1px dotted #000",paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Fec_expe?datInicial.Pws_Fec_expe.split("-")[1]:""}/>
                  <input className="w-100" style={{paddingLeft:"15px",fontWeight:"bolder"}} type="text" name="fechaexpYear" placeholder="AAAA"  value={datInicial.Pws_Fec_expe?datInicial.Pws_Fec_expe.split("-")[0]:""}/>
                </li>
              </ul>
              <ul>
                <li className="w-30">
                  <label htmlFor="fechaexp">Fecha de nacimiento:</label>
                  <input className="w-50" type="text" name="fechaexpDate" placeholder="DD" style={{borderRight: "1px dotted #000",paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Fec_nacime?datInicial.Pws_Fec_nacime.split("-")[2]:""}/>
                  <input className="w-50" type="text" name="fechaexpMonth" placeholder="MM" style={{borderRight: "1px dotted #000",paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Fec_nacime?datInicial.Pws_Fec_nacime.split("-")[1]:""}/>
                  <input className="w-100" style={{paddingLeft:"15px",fontWeight:"bolder"}} type="text" name="fechaexpYear" placeholder="AAAA"  value={datInicial.Pws_Fec_nacime?datInicial.Pws_Fec_nacime.split("-")[0]:""}/>
                </li>
                <li className="w-30">
                  <label htmlFor="Lugar">Lugar de nacimiento:</label>
                  <input type="text" name="Lugar"style={{paddingLeft:"15px",fontWeight:"bolder"}}  value={allCities.filter((filtero:any)=>filtero.s_codigo==datInicial.Pws_Departamento).length>0?allCities.filter((filtero:any)=>filtero.s_codigo==datInicial.Pws_Departamento)[0].s_nombre:""}/>
                </li>
                <li className="w-40">
                  <label htmlFor="Nacionalidad">Nacionalidad:</label>
                  <input type="text" name="Nacionalidad" style={{paddingLeft:"15px",fontWeight:"bolder"}} value="COLOMBIANA"/>
                </li>
              </ul>
              <ul>
                <li className="w-40">
                  <label htmlFor="Dir">Dirección de residencia:</label>
                  <input type="text" name="Dir" style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Direccion_res}/>
                </li>
                <li className="w-20">
                  <label htmlFor="Ciudad">Ciudad:</label>
                  <input type="text" name="Ciudad" style={{paddingLeft:"15px",fontWeight:"bolder"}}  value={allCities.filter((filtero:any)=>filtero.s_codigo==datInicial.Pws_Ciudad_res).length>0?allCities.filter((filtero:any)=>filtero.s_codigo==datInicial.Pws_Ciudad_res)[0].s_nombre:""}/>
                </li>
                <li className="w-20">
                  <label htmlFor="fijo">Teléfon o fijo:</label>
                  <input type="text" name="fijo"  style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Telefono1}/>
                </li>
                <li className="w-20">
                  <label htmlFor="Celular">Celular:</label>
                  <input type="text" name="Celular" style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Telefono2} />
                </li>
              </ul>
            </div>
            <div className="grey">DETALLE DE LA ACTIVIDAD</div>
            <div className="pdfbody">
            <ul>
                <li className="w-20">
                  <label htmlFor="Asalariado">Asalariado</label>
                  <input type="text" name="Asalariado" style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Tip_ocupa=="1"?"X":""}/>
                </li>
                <li className="w-20">
                  <label htmlFor="Independiente">Independiente</label>
                  <input type="text" name="Independiente" style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Tip_ocupa=="2"?"X":""}/>
                </li>
                <li className="w-20">
                  <label htmlFor="Estudiante">Estudiante</label>
                  <input type="text" name="Estudiante"/>
                </li>
                <li className="w-20">
                  <label htmlFor="Rentista">Rentista</label>
                  <input type="text" name="Rentista" />
                </li>
                <li className="w-20">
                  <label htmlFor="Socio">Socio</label>
                  <input type="text" name="Socio" />
                </li>
                <li className="w-20">
                  <label htmlFor="Pensionado">Pensionado</label>
                  <input type="text" name="Pensionado" />
                </li>
              </ul>
              <ul>
                <li className="w-50">
                  <label htmlFor="CIIU">Código de actividad CIIU</label>
                  <input type="text" name="CIIU" />
                </li>
                <li className="w-50">
                  <label htmlFor="Correo">Correo electrónico:</label>
                  <input type="text" name="Correo" style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Correo}/>
                </li>
              </ul>
              <ul>
                <li className="w-50">
                  <label htmlFor="Ocupacion">Ocupación / profesión:</label>
                  <input type="text" name="Ocupacion"  style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Car_emp}/>
                </li>
                <li className="w-50">
                  <label htmlFor="empresa">Nombre de la empresa donde trabaja:</label>
                  <input type="text" name="empresa"  style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Nom_empre}/>
                </li>
              </ul>
              <ul>
                <li className="w-50">
                  <label htmlFor="Cargo">Cargo desempeñado:</label>
                  <input type="text" name="Cargo" style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Car_emp}/>
                </li>
                <li className="w-50">
                  <label htmlFor="Direccion">Dirección empresa:</label>
                  <input type="text" name="Direccion"  style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Direc_emp}/>
                </li>
              </ul>
              <ul>
                <li className="w-30">
                  <label htmlFor="Ciudad2">Ciudad:</label>
                  <input type="text" name="Ciudad2" style={{paddingLeft:"15px",fontWeight:"bolder"}}  value={allCities.filter((filtero:any)=>filtero.s_codigo==datInicial.Pws_Ciud_emp).length>0?allCities.filter((filtero:any)=>filtero.s_codigo==datInicial.Pws_Ciud_emp)[0].s_nombre:""}/>
                </li>
                <li className="w-30">
                  <label htmlFor="Telefono">Teléfono:</label>
                  <input type="text" name="Telefono" style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_tel_emp1}/>
                </li>
                <li className="w-40">
                  <label htmlFor="Correo2">Correo electrónico:</label>
                  <input type="text" name="Correo2"  style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial.Pws_Correo}/>
                </li>
              </ul>
            </div>
            <div className="greyOrange"><h4>PERSONA JURÍDICA</h4></div>
            <div className="pdfbody">
              <ul>
                <li className="w-60">
                  <label htmlFor="Social">Razón Social:</label>
                  <input type="text" name="Social" />
                </li>
                <li className="w-40">
                  <label htmlFor="NIT">NIT:</label>
                  <input type="text" name="NIT" />
                </li>
              </ul>
              <ul>
                <li className="w-40">
                  <label htmlFor="oficina">Dirección oficina principal:</label>
                  <input type="text" name="oficina" />
                </li>
                <li className="w-30">
                  <label htmlFor="Ciudad3">Ciudad</label>
                  <input type="text" name="Ciudad3" />
                </li>
                <li className="w-30">
                  <label htmlFor="Telefono">Teléfono:</label>
                  <input type="text" name="Telefono" />
                </li>
              </ul>
              <ul>
                <li className="w-60">
                  <label htmlFor="Correo3">Correo electrónico:</label>
                  <input type="text" name="Correo3" />
                </li>
                <li className="w-30">
                  <label htmlFor="CIIU">Código CIIU</label>
                  <input type="text" name="CIIU" />
                </li>
              </ul>
              <ul>
                <li className="w-100">
                  <label htmlFor="id">Tipo de empresa:</label>
                  <div className="sublis sublis2 w-100">
                    <label htmlFor="Publica">Pública</label>
                    <input type="text" name="Publica" />
                    <label htmlFor="Privada">Privada</label>
                    <input type="text" name="Privada" />
                    <label htmlFor="Mixta">Mixta</label>
                    <input type="text" name="Mixta" />
                  </div>
                  <div className="sublis sublis2 w-100">
                    <label htmlFor="extranjera">Inversión extranjera</label>
                    <input type="text" name="extranjera" />
                    <label htmlFor="Otra">Otra</label>
                    <input type="text" name="Otra" />
                    <label htmlFor="Cual">Cual?</label>
                    <input type="text" name="Cual" />
                  </div>
                </li>
              </ul>
            </div>
            <div className="orange">2. IDENTIFICACION DE LOS ACCIONISTAS O ASOCIADOS QUE TENGAN DIRECTA O INDIRECTAMENTE MAS DEL 5% DEL CAPITAL SOCIAL, APORTE O PARTICIPACION</div>
            <div className="pdfbody">
              <div className="pdftable">
                <ul>
                  <li>RAZON SOCIAL O NOMBRE COMPLETO</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>TIPO DE IDENTIFICACION</li>
                  <li>
                    <div className="sublis w-100">
                      <label htmlFor="cctable1">C.C.</label>
                      <input type="text" name="cctable1" />
                      <label htmlFor="cetable1">C.E.</label>
                      <input type="text" name="cetable1" />
                      <label htmlFor="nittable1">NIT</label>
                      <input type="text" name="nittable1" />
                    </div>
                  </li>
                  <li>
                    <div className="sublis w-100">
                      <label htmlFor="cctable2">C.C.</label>
                      <input type="text" name="cctable2" />
                      <label htmlFor="cetable2">C.E.</label>
                      <input type="text" name="cetable2" />
                      <label htmlFor="nittable2">NIT</label>
                      <input type="text" name="nittable2" />
                    </div>
                  </li>
                  <li>
                    <div className="sublis w-100">
                      <label htmlFor="cctable3">C.C.</label>
                      <input type="text" name="cctable3" />
                      <label htmlFor="cetable3">C.E.</label>
                      <input type="text" name="cetable3" />
                      <label htmlFor="nittable3">NIT</label>
                      <input type="text" name="nittable3" />
                    </div>
                  </li>
                </ul>
                <ul>
                  <li>NUMERO</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>
            <div className="orange">3. INFORMACION FINANCIERA</div>
            <div className="pdfbody">
              <ul>
                <li className="w-50">
                  <label htmlFor="activos">Total activos</label>
                    <NumberFormat style={{paddingLeft:"15px",fontWeight:"bolder"}} value={parseFloat("0")} displayType={'input'} thousandSeparator={true} prefix={'$'}/>
                </li>
                <li className="w-50">
                  <label htmlFor="pasivos">Total pasivos</label>
                    <NumberFormat style={{paddingLeft:"15px",fontWeight:"bolder"}} value={parseFloat("0")} displayType={'input'} thousandSeparator={true} prefix={'$'}/>
                </li>
              </ul>
              <ul>
                <li className="w-30">
                  <label htmlFor="mensuales">Ingresos mensuales</label>
                    <NumberFormat style={{paddingLeft:"15px",fontWeight:"bolder"}} value={parseFloat(datInicial2.Pws_Ingreso_Principal)} displayType={'input'} thousandSeparator={true} prefix={'$'}/>
                </li>
                <li className="w-30">
                  <label htmlFor="Otros">Otros ingresos</label>
                    <NumberFormat style={{paddingLeft:"15px",fontWeight:"bolder"}} value={parseFloat(datInicial2.Pws_otros_ingresos)} displayType={'input'} thousandSeparator={true} prefix={'$'}/>
                </li>
                <li className="w-40">
                  <label htmlFor="Concepto">Concepto:</label>
                  <input type="text" name="Concepto" style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial2.Pws_Concep_otr_ingre}/>
                </li>
              </ul>
              <ul>
                <li className="w-30">
                  <label htmlFor="Egresos">Egresos mensuales</label>
                    <NumberFormat style={{paddingLeft:"15px",fontWeight:"bolder"}} value={parseFloat("0")} displayType={'input'} thousandSeparator={true} prefix={'$'}/>
                </li>
                <li className="w-30">
                  <label htmlFor="Otros2">Otros egresos</label>
                    <NumberFormat style={{paddingLeft:"15px",fontWeight:"bolder"}} value={parseFloat(datInicial2.Pws_Otros_egresos)} displayType={'input'} thousandSeparator={true} prefix={'$'}/>
                </li>
                <li className="w-40">
                  <label htmlFor="Concepto2">Concepto:</label>
                  <input type="text" name="Concepto2"  />
                </li>
              </ul>
            </div>
            <div className="orange">4. ACTIVIDAD EN OPERACIONES INTERNACIONALES</div>
            <div className="pdfbody"> 
              <ul>
                <li className="w-100">
                  <label htmlFor="moneda">¿Realiza transacciones en moneda extranjera?</label>
                  <div className="sublis sublis2 w-100">
                    <label htmlFor="SI">SI</label>
                    <input type="text" name="SI" style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial2.Pws_Moneda_ext=="1"?"X":""}/>
                    <label htmlFor="NO">NO</label>
                    <input type="text" name="NO" style={{paddingLeft:"15px",fontWeight:"bolder"}}  value={datInicial2.Pws_Moneda_ext=="0"?"X":""}/>
                  </div>
                  <label htmlFor="transaccion">Tipo de transacción:</label>
                  <div className="sublis sublis2 w-100">
                    <label htmlFor="Importacion">Importación</label>
                    <input type="text" name="Importacion" />
                    <label htmlFor="Exportacion">Exportación</label>
                    <input type="text" name="Exportacion" />
                  </div>
                </li>
              </ul>
              <ul>
                <li className="w-10">
                  <label htmlFor="Inversiones">Inversiones</label>
                  <input type="text" name="Inversiones" />
                </li>
                <li className="w-10">
                  <label htmlFor="Prestamos">Préstamos</label>
                  <input type="text" name="Prestamos" />
                </li>
                <li className="w-20">
                  <label htmlFor="Transferencias">Transferencias</label>
                  <input type="text" name="Transferencias" />
                </li>
                <li className="w-10">
                  <label htmlFor="Otros3">Otros</label>
                  <input type="text" name="Otros3" />
                </li>
                <li className="w-50">
                  <label htmlFor="Cual3">Cual?</label>
                  <input type="text" name="Cual3" />
                </li>
              </ul>
              <div className="pdftable">
                <ul>
                  <li>Tipo de producto</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>Identificación o número del producto</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>Entidad</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>Monto</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>Ciudad</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>País</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>Moneda</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>
            <div className="orange">5. PERSONAS EXPUESTAS PUBLICAMENTE</div>
            <div className="pdfbody">
              <ul>
                <li className="w-80" style={{textAlign: "left"}}>
                  <p>¿Por su cargo maneja recursos públicos?</p>
                </li>
                <li className="w-10">
                  <label htmlFor="si2">SI</label>
                  <input type="text" name="si2" style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial3.Pws_Pep_recpublic=="1"?"X":""}/>
                </li>
                <li className="w-10">
                  <label htmlFor="no2">NO</label>
                  <input type="text" name="no2" style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial3.Pws_Pep_recpublic=="0"?"X":""}/>
                </li>
              </ul>
              <ul>
                <li className="w-80" style={{textAlign: "left"}}>
                  <p>¿Por su cargo o actividad ejerce algún grado de poder público?</p>
                </li>
                <li className="w-10">
                  <label htmlFor="si3">SI</label>
                  <input type="text" name="si3"  style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial3.Pws_Pep_poderpublic=="1"?"X":""}/>
                </li>
                <li className="w-10">
                  <label htmlFor="no3">NO</label>
                  <input type="text" name="no3"  style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial3.Pws_Pep_poderpublic=="0"?"X":""}/>
                </li>
              </ul>
              <ul>
                <li className="w-80" style={{textAlign: "left"}}>
                  <p>¿Por su actividad u oficio goza usted de reconocimiento público general?</p>
                </li>
                <li className="w-10">
                  <label htmlFor="si4">SI</label>
                  <input type="text" name="si4" style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial3.Pws_Pep_Reconpublic=="1"?"X":""}/>
                </li>
                <li className="w-10">
                  <label htmlFor="no4">NO</label>
                  <input type="text" name="no4" style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial3.Pws_Pep_Reconpublic=="0"?"X":""}/>
                </li>
              </ul>
              <ul>
                <li className="w-80" style={{textAlign: "left"}}>
                  <p>¿Existe algún vínculo entre usted y una persona considerada públicamente expuesta?</p>
                </li>
                <li className="w-10">
                  <label htmlFor="si5">SI</label>
                  <input type="text" name="si5" style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial3.Pws_Pep_pubexpue=="1"?"X":""} />
                </li>
                <li className="w-10">
                  <label htmlFor="no5">NO</label>
                  <input type="text" name="no5" style={{paddingLeft:"15px",fontWeight:"bolder"}}   value={datInicial3.Pws_Pep_pubexpue=="0"?"X":""}/>
                </li>
              </ul>
              <ul>
                <li className="w-80" style={{textAlign: "left"}}>
                  <p>{`¿Tiene 2° de afinidad y 2° de Consanguinidad (Padres,hermanos,esposa, primos, suegros, cuñados o concuñados) con PEP?`}</p>
                </li>
                <li className="w-10">
                  <label htmlFor="si6">SI</label>
                  <input type="text" name="si6" style={{paddingLeft:"15px",fontWeight:"bolder"}}  value={datInicial3.Pws_Pep_seggraconsa=="1"?"X":""}/>
                </li>
                <li className="w-10">
                  <label htmlFor="no6">NO</label>
                  <input type="text" name="no6"  style={{paddingLeft:"15px",fontWeight:"bolder"}} value={datInicial3.Pws_Pep_seggraconsa=="0"?"X":""}/>
                </li>
              </ul>
            </div>
            <div className="orange">6. INFORMACION BANCARIA</div>
            <div className="pdfbody">
            <div className="pdftable">
                <ul>
                  <li>Entidad</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>Sucursal</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>Teléfono sucursal</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>Tipo de cuenta</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <ul>
                  <li>No. de Cuenta</li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>
            <div className="orange">7. DECLARACIÓN DE ORIGEN DE FONDOS</div>
            <div className="pdfbody">
              <div className="para">
                <p>Declaro expresamente que:</p>
                <p>{`1. Los recursos que poseo provienen de las siguientes fuentes ( Detalle ocupación, oficio, actividad,negocio,etc)`}</p>
                <hr className="fs w-70" />
                <br />
                <p>2. Tanto mi actividad, profesión u oficio es licita y la ejerzo dentro del marco legal y los recursos que poseo no provienen de actividades ilícitas de las contempladas en el código penal Colombiano.</p>
                <br />
                <p>3. La Información que he suministrado en este documento es veraz, verificable y me obligo a actualizarla anualmente.</p>
                <br />
                <p>4. Autorizo a FINANCAPITAL para solicitar, consultar, suministrar, reportar o divulgar a cualquier entidad con la que mantenga una relación comercial vigente o que se encuentre debidamente autorizado para manejar o administrar bases de datos, incluidas las entidades gubernamentales la información contenida en este formato. Esta información es confidencial y puede ser solicitada por la Superintendencia de Sociedades o demás autoridades competentes en Colombia.</p>
                <br />
              </div>
            </div>
            <div className="orange">8. AUTORIZACION CONSULTAS CENTRALES DE RIESGO</div>
            <div className="pdfbody">
              <div className="para">
                <p>{` En mi calidad de titular de la información, actuando libre y voluntariamente, autorizo a FINANCAPITAL NIT: 901583873, o a quien represente sus derechos, con domicilio principal en la Calle 146 7f 80, en Usaquén (Bogotá), teléfono 3125546540, para consultar a través de cualquier fuente, realizar por cualquier medio la comunicación previa al reporte de información negativa y reportar a Data crédito o en cualquier otra central de información de riesgo, las informaciones y referencias relativas a mi nombre y/o la sociedad que represento, comportamiento y crédito comercial, hábitos de pago, manejo de cuenta (s) y en general, al cumplimiento de mis obligaciones pecuniarias. Igualmente en mi calidad de Titular de la información, actuando libre y voluntariamente, autorizo a FINANCAPITAL, o quien represente sus derechos, y/o a Experian Colombia S.A. (en adelante Data Crédito Experian), Carrera 7 No. 76- 35 en Bogotá D.C., tel 3191400, o quien represente sus derechos, a acceder a mis datos personales contenidos en la base de datos Aportes en Línea (Aportes En Línea S.A.900147238-2), Colfondos y/o administradoras de pensiones y demás Operadores de información de seguridad social autorizados por el Ministerio de Salud y Protección Social, a mis datos personales recolectados por medio del presente formulario y a mis datos personales contenidos en la base de datos de DataCrédito Experian (Operador de información crediticia), en adelante mi información personal, para darle tratamiento en los términos expresados en la Política de Tratamiento de la Información Personal de FINANCAPITAL, o quien represente sus derechos y/o DataCrédito Experian, y para finalidades de gestión de riesgo crediticio tales como: (1) elaboración y circulación a terceros de scores crediticios, herramientas de validación de ingresos, herramientas predictivas de ingresos, herramientas para evitar el fraude y en general, herramientas que le permitan a los Suscriptores de DataCrédito Experian, adelantar una adecuada gestión del riesgo crediticio. (2) Compararla, contrastarla y complementarla con la información financiera, comercial, crediticia, de servicios y proveniente de terceros países de DataCrédito Experian. (3) Compararla, contrastarla y complementarla con la información personal de Mi datacrédito.`}</p>
                <br />
              </div>
            </div>
            <div className="orange">9. AUTORIZACION PARA TRATAMIENTO DATOS PERSONALES ,VISITAS DOMICILIARIAS, NOTIFICAR POR CUALQUIER MEDIO</div>
            <div className="pdfbody">
              <div className="para">
                <p>{`Declaro además, que entrego de forma libre, voluntaria y doy mi autorización expresa para que FINANCAPITAL, identificada con Nit. 901583873, en lo sucesivo "La Compañía", actuando como responsable del tratamiento de los datos personales y considerando lo dispuesto por la ley 1581 de 2012, el decreto reglamentario 1377 de 2013, decreto único 1074 de 2015, ley 1266 de 2008 y demás normas que los adicionen, modifiquen o deroguen y al manual de políticas de protección de datos personales, diseñados por la compañía, trate mis Datos Personales, con la finalidad de medir niveles de satisfacción, informar sobre campañas de servicio, comunicar campañas promocionales, realizar encuestas, realizar recordatorio para mantenimientos, ejecutar campañas de fidelización, enviar invitaciones a eventos, rifas, realizar actualización de datos, invitar a pruebas de vehículos, ofrecimiento de productos y servicios, comunicar noticias de las marcas que comercialicen y de la red de ventas y servicios, comunicar información relacionada con productos para la financiación en la adquisición de bienes y servicios y para realizar inspecciones domiciliarias, registros de evidencias y verificación de los datos por mi suministrados para el trámite del crédito`}</p>
                <br />
              </div>
            </div>
            <div className="orange">10. AUTORIZACION CONSULTA EN LISTAS NACIONALES O INTERNACIONALES PARA EL CONTROL LA/FT</div>
            <div className="pdfbody">
              <div className="para">
                <p>{`1. Acepto la verificacion de Sagrilaft realizada por FINANCAPITAL, de manera que velaré por su cumplimiento manteniendo los controles para evitar que FINANCAPITAL sea utilizado en actividades ilícitas. Acepto que FINANCAPITAL, a que, en caso de incumplimiento de lo anterior, de por terminado unilateralmente, y sin que haya lugar a indemnización alguna a favor mío, todos los contratos que haya celebrado con dicha empresa.`}</p>
                <br />
                <p>{`2. Que informaré inmediatamente de cualquier circunstancia que modifique la presente declaracion.`}</p>
                <p>{`3. Que toda información suministrada en este documento es cierta.`}</p>
                <br />
              </div>
            </div>
            <div className="orange">11. FIRMA Y HUELLA</div>
            <div className="pdfbody">
              <div className="para">
                <p>{`Como constancia de haber leído,entendido y aceptado lo anterior.`}</p>
                <div className="sign-photo">
                  <div className="sign">
                    <p >{arreglos.length>3?<>
                    <p style={{textAlign:"center"}}>OTP : {arreglos[3]}</p>
                    <p style={{textAlign:"center"}}>FECHA : {Moment(new Date()).format('DD/MM/YYYY')}</p>
                    <p style={{textAlign:"center"}}>{datInicial.Pws_Nombres+" "+datInicial.Pws_Apellidos1 +" "+datInicial.Pws_Apellidos2}</p>
                    </>:<></>}</p>
                    <hr className="fs w-100" />
                    <p>Firma del representante legal ,cliente, o proveedor Huella Indice Derech</p>
                  </div>
                  <div className="photo">
                    <div className="pic"></div>
                    <p>Huella Indice Derecho</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="orange">12. ESPACIO ESCLUSIVO PARA LA ENTIDAD</div>
            <div className="grey grey-left">Verificación de la información</div>
            <div className="pdfbody">
              <ul>
                <li className="w-30 labelup">
                  <label htmlFor="colaborador">Nombre del colaborador quien verifica:</label>
                  <input type="text" name="colaborador" />
                </li>
                <li className="w-30 labelup">
                  <label htmlFor="Cargo4">Cargo:</label>
                  <input type="text" name="Cargo4" />
                </li>
                <li className="w-20 labelup">
                  <label htmlFor="Regional2">Regional:</label>
                  <input type="text" name="Regional2" />
                </li>
                <li className="w-20 labelup">
                  <label htmlFor="fechaver">fecha verificación</label>
                  <div className="verinputs">
                    <input className="w-50" type="text" name="fechaverDate" style={{borderRight: "1px dotted #000"}} />
                    <input className="w-50" type="text" name="fechaverMonth" style={{borderRight: "1px dotted #000"}} />
                    <input className="w-100" type="text" name="fechaverYear" />
                  </div>
                </li>
              </ul>
            </div>
        </div>
    )
}